import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, message, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'
import {
  GetFeeApprovedList,
  GetLeaveApprovedList,
} from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'

const LeaveAppList = () => {
  const storedBranchId = sessionStorage.getItem('branch_id')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchLeaveApprovedList()
  }, [])

  const fetchLeaveApprovedList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${GetLeaveApprovedList}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: item.student?.full_name,
        from_date: item.from_date || '-',
        to_date: item.to_date || '-',
        reason: item.reason || '-',

        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      message.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (item.full_name ?? '').toLowerCase().includes(search)
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'From Date', dataIndex: 'from_date' },
    { title: 'To Date', dataIndex: 'to_date' },
    { title: 'Reason', dataIndex: 'reason' },
  ]

  const exportToExcel = () => {
    const excelData = filteredData.map((item) => {
      const student = { ...item.full_data }

      // Flatten nested objects
      student.admin = student.admin?.username || ''
      student.documents = JSON.stringify(student.documents || {})

      return student
    })

    const worksheet = XLSX.utils.json_to_sheet(excelData)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Leave Approved')

    XLSX.writeFile(workbook, 'Leave_Approved_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Leave Approved List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>
    </div>
  )
}

export default LeaveAppList
